"use client";

import { ChevronLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { trackEvent } from "../analytics-wrapper";
import { TemplateDetails } from "./template-details";
import { TemplateData } from "./templates-action";

export function TemplateModal({
  isOpen,
  closeModal,
  template,
  idx,
  handleIdx,
}: {
  template: TemplateData | undefined;
  isOpen: boolean;
  closeModal: () => void;
  idx: number | undefined;
  handleIdx: (idx: number) => void;
}) {
  useEffect(() => {
    if (isOpen && template) {
      trackEvent({ eventName: "templateModal", action: "view", category: template.id });
    }
  }, [isOpen, template?.id]);

  const baseUrl = process.env.NEXT_PUBLIC_USER_VIDEO_CDN_URL;

  if (!baseUrl) return null;

  return (
    <dialog className="modal modal-bottom sm:modal-middle" open={isOpen} onClose={closeModal}>
      <div className="max-h-auto modal-box relative max-h-screen w-full max-w-7xl! overflow-visible bg-transparent px-0 py-0 sm:px-14">
        <button
          className="btn btn-circle absolute right-0 top-0"
          onClick={closeModal}
          role="button"
          aria-label="Close Template Modal Button"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        {idx !== undefined && (
          <>
            <button
              className="btn btn-circle btn-md absolute left-0 top-1/2 hidden backdrop-blur-md sm:flex"
              onClick={() => handleIdx(idx - 1)}
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <button
              className="btn btn-circle btn-md absolute right-0 top-1/2 hidden backdrop-blur-md sm:flex"
              onClick={() => handleIdx(idx + 1)}
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </>
        )}

        {template && <TemplateDetails template={{ ...template, templateContent: null }} />}
      </div>

      <form method="dialog" className="modal-backdrop bg-black/80">
        <button>close</button>
      </form>
    </dialog>
  );
}
